export default function discreteLegendUtil(itemColor, isSelectorLegend, horizontal) {
    function legend(g) {
        function drawLegend() {
            // Code to fill the color
            // Styling for color selector legend
            g.selectAll("g.legendCells")
                .data(itemColor)
                .enter()
                .append("g")
                .append("rect")
                .append("title")
                .text(function (d) {
                return d["name"];
            })
                .attr("class", "rectLabel")
                .style("cursor", "pointer")
                .style("pointer-events", "all");
            g.selectAll("rect")
                .attr("height", 1)
                .attr("width", 1)
                .style("fill", function (d) {
                return d["color"];
            });
            if ((horizontal && !isSelectorLegend) ||
                (horizontal === true && isSelectorLegend)) {
                g.selectAll("rect")
                    .attr("x", function (_d, i) {
                    return i;
                })
                    .attr("y", 0);
            }
            else if ((!horizontal && !isSelectorLegend) ||
                (horizontal === false && isSelectorLegend)) {
                g.selectAll("rect")
                    .attr("y", function (_d, i) {
                    return i;
                })
                    .attr("x", 0);
            }
            else {
                g.selectAll("rect")
                    .attr("x", function (_d, i) {
                    return i;
                })
                    .attr("y", 0);
            }
        }
        drawLegend();
    }
    return legend;
}
//# sourceMappingURL=discreteLegend.js.map